import { render, staticRenderFns } from "./FilterSpaces.vue?vue&type=template&id=7b88dc22&"
import script from "./FilterSpaces.vue?vue&type=script&lang=ts&"
export * from "./FilterSpaces.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b88dc22')) {
      api.createRecord('7b88dc22', component.options)
    } else {
      api.reload('7b88dc22', component.options)
    }
    module.hot.accept("./FilterSpaces.vue?vue&type=template&id=7b88dc22&", function () {
      api.rerender('7b88dc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/FilterSpaces.vue"
export default component.exports